// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");

var match = process.env.NODE_ENV;

var currentEnv = match === "development" ? /* Development */1 : /* Production */0;

function runOnlyInDev(fn) {
  if (currentEnv) {
    return Curry._1(fn, undefined);
  }
  
}

var latestCdnUrl = "https://static-cdn.arte.tv/static/design-system";

exports.latestCdnUrl = latestCdnUrl;
exports.currentEnv = currentEnv;
exports.runOnlyInDev = runOnlyInDev;
/* match Not a pure module */
